import MEGAPHONE from '../../types/megaphone'
import { getMegaphoneByProductId, convertPositionToPercent } from './shared'

const MIN_POSITION_TO_ANIMATE = 75
const BASE_UNIT = 100
const DECREASE_TIME = 15
const DECREASE_RATE = (BASE_UNIT - MIN_POSITION_TO_ANIMATE) / DECREASE_TIME
let decreasePositionInterval = null

const hasAnyPositionToAnimate = (products) => {
  return products.some((megaphone) => shouldAnimate(megaphone.position))
}

/* Decrease animation happens when position is bigger than MIN_POSITION_TO_ANIMATE on each hundred
  so, from 100 to 85, from 200 to 185 or from 300 to 285 */
const shouldAnimate = (position) => {
  return (position % BASE_UNIT > MIN_POSITION_TO_ANIMATE) ||
    (position % BASE_UNIT === 0)
}

const decreaseHighestPositions = (state) => {
  if (decreasePositionInterval) {
    clearInterval(decreasePositionInterval)
  }

  if (hasAnyPositionToAnimate(state.products)) {
    decreasePositionInterval = setInterval(() => {
      state.products = state.products.map((megaphone) => {
        if (shouldAnimate(megaphone.position)) {
          megaphone.position -= DECREASE_RATE
          megaphone.positionPercent = convertPositionToPercent(megaphone.position)
        }

        return megaphone
      })

      if (!hasAnyPositionToAnimate(state.products)) {
        clearInterval(decreasePositionInterval)
      }
    }, 1000)
  }
}

const releaseProductDelay = (state, { product_id }) => {
  state.products = state.products.map((megaphone) => {
    if (megaphone.product_id === product_id) {
      megaphone.delay = 0
    }

    return megaphone
  })
}

const releaseProductsAfterDelay = (state, products) => {
  products.map((megaphone) => {
    if (megaphone.delay) {
      setTimeout(() => {
        releaseProductDelay(state, megaphone)
      }, megaphone.delay * 1000)
    }
  })
}

const setModalState = (state) => {
  const megaphone = getMegaphoneByProductId(state.products, state.productToBoost)
  const hasPaidOption = megaphone.exposure !== 'maximum_for_free'
  const text = state.messages.find((item) => {
    return item.exposure === megaphone.exposure && item.message
  }) || { message: '', highlight: '' }

  state.modal = {
    isOpened: hasPaidOption,
    type: megaphone.exposure,
    productId: megaphone.product_id,
    newPrice: megaphone.price_to_increase_exposure,
    price: megaphone.price,
    discount: megaphone.discount,
    message: text.message,
    highlight: text.highlight,
    planIsMegaphoneable: megaphone.plan_is_megaphoneable,
    upgradeablePlanId: megaphone.upgradeable_plan_id
  }
}

export default {
  [MEGAPHONE.MUTATIONS.SET_PRODUCTS]: (state, payload) => {
    state.products = payload

    decreaseHighestPositions(state)
    releaseProductsAfterDelay(state, state.products.filter((megaphone) => megaphone.delay))
  },
  [MEGAPHONE.MUTATIONS.SET_MESSAGES]: (state, payload) => {
    state.messages = payload
  },
  [MEGAPHONE.MUTATIONS.SET_BOOST_ACTION_ERROR]: (state, payload) => {
    state.boostActionError = payload
  },
  [MEGAPHONE.MUTATIONS.SET_PRODUCT_TO_BOOST]: (state, payload) => {
    state.productToBoost = payload

    if (payload) {
      setModalState(state)
    }
  },
  [MEGAPHONE.MUTATIONS.UPDATE_PRODUCT]: (state, payload) => {
    state.products = state.products.map((megaphone) => {
      if (megaphone.product_id === payload.product_id) {
        const updatedMegaphone = Object.assign(megaphone, payload)

        releaseProductsAfterDelay(state, [ updatedMegaphone ])

        return updatedMegaphone
      } else {
        return megaphone
      }
    })

    decreaseHighestPositions(state)
  },
  [MEGAPHONE.MUTATIONS.SET_MODAL_PARAMS]: (state, payload) => {
    state.modal = {
      ...state.modal,
      ...payload
    }
  },
  [MEGAPHONE.MUTATIONS.SET_MODAL_IS_OPENED]: (state, payload) => {
    if (payload) {
      state.modal = {
        ...state.modal,
        isOpened: true
      }
    } else {
      state.modal = {
        isOpened: false,
        type: null
      }
    }
  },
  [MEGAPHONE.MUTATIONS.SET_STATS]: (state, payload) => {
    state.enabled = payload
  }
}
